import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import AHMIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import { SOMETHING_WENT_WRONG } from "../../../utils/constants";
import AddMunicipalityModal from "../components/add-municipality/AddMunicipality";
import MunicipalitiesList from "./helpers/MunicipalityList";
import styles from "./style";
import { Add } from "@mui/icons-material";
import BreadCrumbs from "../components/BreadCrumbs/BreadCrumbs";

export default function AdminDashboard() {
  const classes = styles();
  const [openAddMunicipalityModal, setOpenAddMunicipalityModal] = useState(false);
  const [municipalityTableData, setMunicipalityTableData] = useState([]);
  const [modalDefaultValues, setModalDefaultValues] = useState({});

  useEffect(() => {
    getMunicipalitiesData();
  }, []);

  const handleAddMunicipalityModalClose = () => {
    setModalDefaultValues({});
    setOpenAddMunicipalityModal(false);
  }

  const getMunicipalitiesData = () => {
    AHMIS.get(API_URL.municipality)
      .then(response => {
        setMunicipalityTableData(response.data);
        setOpenAddMunicipalityModal(false);
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const handleRowEdit = id => {
    AHMIS.get(API_URL.municipality + "/" + id).then(response => {
      setModalDefaultValues(response.data);
      setOpenAddMunicipalityModal(true);
    }).catch(error => {
      AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
    });
  }

  const handleAddMunicipalityModalSubmit = data => {
    data.id = modalDefaultValues.id;
    data.email = data?.email?.toLowerCase().trim();
    AHMIS.post(API_URL.municipality, data)
      .then(response => {
        if (response.data.type === "success") {
          setMunicipalityTableData(response.data.objectList);
          handleAddMunicipalityModalClose();
          getMunicipalitiesData()
        }
        AddAlertMessage({
          type: response.data.type,
          message: response.data.message
        });
      })
      .catch(error => {
        AddAlertMessage({
          type: "error",
          message: SOMETHING_WENT_WRONG
        });
      });
  }

  return (
    <>
      <Box borderBottom={1}>
        <BreadCrumbs />
      </Box>
      <Box className={classes.dashboardContainer} borderBottom={1} mt={2}>
        <Typography variant="h5">
          स्वास्थ्य व्यवस्थापन सूचना प्रणाली - सबै नगरपालिकाहरु
        </Typography>
        <Box display="flex" alignItems="center">
          <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => { setOpenAddMunicipalityModal(true) }}>नयाँ पालिका थप्नुहोस्</Button>
        </Box>
      </Box>
      <Box>
        <MunicipalitiesList tableData={municipalityTableData} editRow={handleRowEdit} />
      </Box>
      <AddMunicipalityModal handleModalSubmit={handleAddMunicipalityModalSubmit.bind(this)} showAddMunicipalityModal={openAddMunicipalityModal} handleAddMunicipalityModalClose={handleAddMunicipalityModalClose} defaultValues={modalDefaultValues} />
    </>
  );
}
